import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TSearchFilterGroupInfo } from '../../filter/model/ui-filter.types';

@Component({
  selector: 'ui-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss'],
})
export class SearchFilterComponent {
  @Input() filterModel!: TSearchFilterGroupInfo;

  @Output() searchQueryEvent = new EventEmitter<TSearchFilterGroupInfo>();

  constructor() {}

  handleChange($event: Event) {
    if ($event && $event.target) {
      const searchQuery = {
        ...this.filterModel,
        text: ($event.target as any).value,
      };
      this.searchQueryEvent.emit(searchQuery); //TODO
    }
  }
}
